import React, { Component } from 'react';
import { Banner } from './Home/Banner';
import { SeoMeta } from './Layout/SeoMeta';
import { PopCategory } from './Home/PopCategory';
import { PopArtists } from './Home/PopArtists';
import '../sass/home.scss';
import { GameRules } from './Home/GameRules';
import { Register } from './Home/Register';
import { Questions } from './Home/Questions';
import { Contest } from './Home/Contest';
import { Recaptcha } from './Home/Recaptcha';



export class Home extends Component {
    static displayName = Home.name;

    constructor(props) {
        super(props);
        this.state = {
            data: {},
            sponsers: {},
            catData: {},
            breadcrums: [],
            isRegistered: false,
            recaptchaToken: null
        };
        this.state.breadcrums.push({ title: 'Home', url: '/' });
        this.changeIsregistedState = this.changeIsregistedState.bind(this);
        this.changeIsSponserLoaded = this.changeIsSponserLoaded.bind(this);
        this.recaptchaTokenChange = this.recaptchaTokenChange.bind(this);
    }


    componentDidMount() {

        window.addEventListener('scroll', this.handleScroll);
        //this.populateContests();
        //this.populateWeatherData();
        // this.populateActiveSponser();
    }
    handleScroll(event) {
        setTimeout(() => {
            var sticky = document.getElementById("header"),
                scroll = window.scrollY;
            if (scroll >= 50) sticky.classList.add('sticky');
            else sticky.classList.remove('sticky');
        }, 100);

    }


    async populateSponsers(id) {
        const response = await fetch('v1/api/sponserById?sponserId=' + id, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });
        const data = await response.json();
        this.setState({ sponser: data, loading: false });

        if (data != null && data.Status) {

            this.populateQuestions(id);
            this.populateGameRules(id);

        }

    }

    async populateQuestions(id) {
        const response = await fetch('v1/api/Questions?sponserId=' + id, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });
        const data = await response.json();
        this.setState({ questions: data, loading: false });

        if (data != null && data.Status) {



        }

    }



    async populateContests() {
        const response = await fetch('v1/api/contests', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });
        const data = await response.json();
        this.setState({ contest: data, loading: false });

        if (data != null && data.Status) {



        }

    }


    changeIsregistedState(userId) {
        this.setState({ userId: userId }, function () {
            console.log("userId Id from loaded " + this.state.userId);
        });

    }

    changeIsSponserLoaded(sponserId) {
        this.setState({ sponserId: sponserId }, function () {
            console.log("Sponser Id from loaded " + this.state.sponserId);
        });

    }

    async recaptchaTokenChange(value) {
        this.setState({ recaptchaToken: value });


        //const request = new Request("v1/api/master/verifytoken", {
        //    method: "POST",
        //    body: JSON.stringify(value),
        //});

        //const response = await fetch(request, {
        //    headers: {
        //        "Content-Type": "application/json",
        //    }
        //});
        //const data = await response.json();
        //console.log(data);
    }

    //{isRegistered  && <Questions></Questions>}
    render() {

        return (

            <>
                <Recaptcha recaptchaTokenChange={this.recaptchaTokenChange}></Recaptcha>
                <Banner onChange={this.changeIsSponserLoaded} ></Banner>
                <GameRules></GameRules>
                <Register onChange={this.changeIsregistedState} sponserId={this.state.sponserId} recaptchaToken={this.state.recaptchaToken} ></Register>

            </>
        );
    }
}
